import { css, html, LitElement } from "lit"
import "../popups/PopupConnexion.js"
import "../popups/PopupMonProfil.js"
import "@luminecence/composants/PopupConfirmation"
import PopupBase from "@luminecence/composants/PopupBase"
import "@luminecence/composants/BoutonIcone"
import Toast, { TOAST_TYPES } from "@luminecence/composants/Toast"
import GestionnaireChangementConnexion from "./GestionnaireChangementConnexion.js"

export const MODE_CONNEXION = "connexion"
export const MODE_INSCRIPTION = "inscription"

export default class Connexion extends LitElement {
  static properties = { mode: String, pseudo: { type: String, state: true } }

  static styles = css`
  #zone-connexion {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 2rem;
        color: white;
        --icone-couleur: white;
        --couleur-texte: white;
    }

    .pseudo {
      cursor: pointer;
      font-weight: bold;
      text-decoration: underline;
      background-color: transparent;
      border: none;
      color: inherit;
      font-size: 1.5rem;
    }

    #zone-connexion p-bouton-icone {
      --font-size-texte: 1.5rem;
      --taille-icone-bouton: 2.5rem;
    }
  `

  gestionnaireChangementConnexion = new GestionnaireChangementConnexion()

  constructor() {
    super()
    this.mode = MODE_CONNEXION
  }

  connectedCallback() {
    super.connectedCallback()
    window.authentification.gestionnaireChangementConnexion = this.gestionnaireChangementConnexion

    const fonctionDeclenchementCallbacksConnexion = async (pseudo) => {
      this.pseudo = (await window.authentification.bdd.membres.recupererLePseudoDuMembreConnecte()) || pseudo || ""
    }

    const fonctionDeclenchementCallbacksDeconnexion = () => {
      this.pseudo = ""
    }

    this.gestionnaireChangementConnexion.callbackUtilisateurConnecte.push(fonctionDeclenchementCallbacksConnexion)
    this.gestionnaireChangementConnexion.callbackUtilisateurDeconnecte.push(fonctionDeclenchementCallbacksDeconnexion)
  }

  render() {
    this.initialiserPseudo()
    return html`
        <div id="zone-connexion">
    ${
      window.authentification.getUser()
        ? html`${this.afficherPseudo()}
          `
        : html`<p-bouton-icone texte="Se connecter" icone="connexion" @click=${this.afficherConnexion}></p-bouton-icone>
        <p-bouton-icone texte="S'inscrire" @click=${this.afficherInscription}></p-bouton-icone>`
    }
    </div>
    `
  }

  async initialiserPseudo() {
    await window.authentification.attendreAuthPret()
    const user = window.authentification.getUser()

    if (!user) {
      return
    }

    const pseudoBdd = await window.authentification.bdd.membres.recupererLePseudoDuMembreConnecte()
    this.pseudo = pseudoBdd || user.displayName || ""
  }

  afficherPseudo() {
    return html`<button class="pseudo" tabindex="0" role="button" @click=${this.afficherMonProfil}>${this.pseudo}</button>
    <p-bouton-icone texte="Se déconnecter" icone="deconnexion" @click=${this.deconnecter}></p-bouton-icone>`
  }

  async afficherMonProfil(event) {
    event.stopPropagation()
    const resultat = /** @type {any} */ (await PopupBase.ouvrirEtAttendre("p-popup-mon-profil", { pseudo: this.pseudo }))

    if (resultat) {
      await this.changerMonProfil(resultat.pseudo)
    }
  }

  async afficherConnexion(event) {
    event.stopPropagation()
    const resultat = /** @type {any} */ (await PopupBase.ouvrirEtAttendre("p-popup-connexion", { mode: MODE_CONNEXION }))

    if (resultat) {
      this.pseudo = resultat.pseudo
      Toast.afficher("Connexion réussie !", TOAST_TYPES.SUCCES)
    }
  }

  async afficherInscription(event) {
    event.stopPropagation()
    const resultat = /** @type {any} */ (await PopupBase.ouvrirEtAttendre("p-popup-connexion", { mode: MODE_INSCRIPTION }))

    if (resultat) {
      this.pseudo = resultat.pseudo
    }
  }

  async deconnecter() {
    await window.authentification.deconnecterUtilisateur()
    this.pseudo = ""
    this.dispatchEvent(new CustomEvent("deconnexion", { bubbles: true, composed: true }))
  }

  async changerMonProfil(pseudo) {
    this.pseudo = pseudo
    await window.authentification.bdd.membres.modifierLePseudoDuMembreConnecte(pseudo)
  }
}
customElements.define("p-connexion", Connexion)
